import script from "./SchemaView.vue?vue&type=script&setup=true&lang=js"
export * from "./SchemaView.vue?vue&type=script&setup=true&lang=js"

import "./SchemaView.vue?vue&type=style&index=0&id=2e745593&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e745593"]])

export default __exports__